import React from 'react';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { HeroSection } from '@/components/home/HeroSection';
import { ChallengeSection } from '@/components/home/ChallengeSection';
import { WealthSection } from '@/components/home/WealthSection';
import { BridgeSection } from '@/components/home/BridgeSection';
import { BenefitsSection } from '@/components/home/BenefitsSection';
import { MissionsSection } from '@/components/home/MissionsSection';
import { ValueSection } from '@/components/home/ValueSection';
import { CTASection } from '@/components/home/CTASection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <ChallengeSection />
        <WealthSection />
        <BridgeSection />
        <BenefitsSection />
        <MissionsSection />
        <ValueSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
